import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetIsCap, GetIsCapResponse } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetIsCapResponse, GetIsCapResponse>) => response?.data?.isCap;

const getError = (response?: SWRResponse<GetIsCapResponse, GetIsCapResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetIsCapResponse, GetIsCapResponse>) => ({
    isCap: response?.data?.isCap
});

export const useCapStatus = (firstName?: string, lastName?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!firstName || !lastName) {
            return undefined;
        }

        return () => {
            return new GetIsCap({firstName, lastName});
        };
    }, [firstName, lastName])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useCapStatus;

